// Central content store for Best Bizz Financial & Management Services N.V.
// Real company information only. Clearly marked placeholders where data is missing.

export const COMPANY = {
  name: "Best Bizz Financial & Management Services N.V.",
  shortName: "Best Bizz Financial",
  phone: "+297 587 0606",
  phoneHref: "tel:+2975870606",
  email: "office@bestbizz.biz",
  emailHref: "mailto:office@bestbizz.biz",
  addressLine1: "Sabana Liber 5B",
  addressLine2: "Oranjestad, Aruba",
  hoursPlaceholder: "Monday – Friday, 8:00 AM – 5:00 PM (AST)",
  since: "2011",
  mapEmbed:
    "https://www.google.com/maps?q=Sabana%20Liber%205B%2C%20Oranjestad%2C%20Aruba&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Sabana+Liber+5B%2C+Oranjestad%2C+Aruba",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100012157863431",
    instagram: "https://www.instagram.com/bestbizzfinancials/",
    linkedin:
      "https://www.linkedin.com/in/best-bizz-financial-and-management-services-b859771bb/",
  },
};

export const HERO = {
  overline: "Accounting · Bookkeeping · Payroll · Consultancy",
  headline: "Affordable Bookkeeping, Payroll & Consultancy",
  subheadline: "You own the business. We manage the numbers.",
  paragraph:
    "Since 2011, Best Bizz Financial has helped businesses across Aruba stay organized, compliant and confident about their finances — with personal service and fixed, predictable monthly fees.",
  primaryCta: "Request a Quote",
  secondaryCta: "Our Services",
};

export const ABOUT_HIGHLIGHTS = [
  { icon: "MapPin", label: "Serving Aruba since 2011" },
  { icon: "Cloud", label: "QuickBooks Online" },
  { icon: "BadgeDollarSign", label: "Fixed Monthly Fees" },
  { icon: "Clock", label: "24/7 Access" },
  { icon: "HeartHandshake", label: "Personal Service" },
];

export const SERVICES = [
  {
    icon: "BookOpen",
    title: "Bookkeeping",
    summary:
      "Accurate, up-to-date records maintained in QuickBooks Online, so you always know exactly where your business stands.",
    points: [
      "Monthly transaction recording & reconciliation",
      "Accounts payable and receivable management",
      "Clear, timely financial statements",
      "Fixed, predictable monthly fees",
    ],
  },
  {
    icon: "Users",
    title: "Payroll",
    summary:
      "Reliable payroll processing that keeps your team paid correctly and on time, while you stay compliant with local requirements.",
    points: [
      "Accurate salary and wage processing",
      "Payslips and payroll reporting",
      "Deductions handled with care",
      "Consistent, on-schedule payments",
    ],
  },
  {
    icon: "LineChart",
    title: "Consultancy",
    summary:
      "Practical financial and management guidance to help you make informed decisions and plan for sustainable growth.",
    points: [
      "Financial insight and planning support",
      "Business and management advice",
      "Guidance tailored to your goals",
      "A trusted partner you can rely on",
    ],
  },
];

export const WHY_CHOOSE_US = [
  {
    icon: "ShieldCheck",
    title: "Trusted Since 2011",
    text: "More than a decade of dependable service to businesses across Aruba.",
  },
  {
    icon: "Cloud",
    title: "QuickBooks Online",
    text: "Modern, cloud-based accounting that keeps your books accurate and accessible.",
  },
  {
    icon: "BadgeDollarSign",
    title: "Affordable Monthly Pricing",
    text: "Fixed monthly fees with no surprises, built for growing businesses.",
  },
  {
    icon: "HeartHandshake",
    title: "Personal Service",
    text: "A dedicated, approachable partner who knows you and your business.",
  },
  {
    icon: "LifeBuoy",
    title: "Reliable Financial Support",
    text: "Consistent, professional support you can count on all year round.",
  },
];

export const BOOKKEEPING_FEATURE = {
  overline: "Bookkeeping, done right",
  heading: "Keep your books accurate, organized and always up to date",
  text:
    "We handle the day-to-day recording, reconciliation and reporting so your numbers are always ready when you need them. With QuickBooks Online, your financial information stays secure, accurate and accessible 24/7 — giving you the clarity to focus on running your business.",
  cta: "Learn More",
};

export const WHY_OUTSOURCE = [
  {
    icon: "PiggyBank",
    title: "Save Money",
    text: "Avoid the cost of an in-house department. Get professional bookkeeping for a fixed, affordable monthly fee.",
  },
  {
    icon: "Clock",
    title: "Save Time",
    text: "Reclaim the hours spent on paperwork and admin, and invest them back into what you do best — your business.",
  },
  {
    icon: "SlidersHorizontal",
    title: "Flexible Solutions",
    text: "Services that adapt as you grow, tailored to the size and needs of your business.",
  },
];

export const STATS = [
  { value: "35+", label: "Bookkeeping Clients" },
  { value: "27+", label: "Payroll Clients" },
  { value: "42+", label: "Full-Service Clients" },
  { value: "12M+", label: "Florins Managed" },
];

// Real client testimonials. Papiamento testimonial kept in its original language.
export const TESTIMONIALS = [
  {
    quote:
      "At home feeling — that's the way you feel as soon as you enter Best Bizz' office. Soraya and her crew are always there to answer any question you may have, especially if you are a new business owner. We from 297sports & Media strongly recommend Best Bizz Financial Management Services for all your business needs.",
    name: "Jessica Krozendijk-Kelly",
    role: "Director, 297 Sports & Media",
    logo: "/clients/297-sports.png",
  },
  {
    quote:
      "On behalf of the company, thank you for the great and attentive service. We appreciate the fast response in helping us solve any challenges we have. Best Bizz has made our service to our clients prompt and reliable. Absolutely awesome — keep it up, guys!",
    name: "Sandy Rasmijn-Leito",
    role: "Owner, Lion Fish Swim School",
    logo: "/clients/lion-fish.png",
  },
  {
    quote:
      "Best Bizz has been one of the best decisions we have made as a business. Soraya and her team understand small and large businesses alike and give the best advice every step of the way. Soraya has always ensured to provide up-close care and insight, which goes to show how incredibly passionate she is about her craft. On a more personal note: thank you for all the extra effort, care, love, and golden advice you have provided.",
    name: "Jerusho Fernandez",
    role: "Owner, CleanWheels",
    logo: "/clients/cleanwheels.png",
  },
  {
    quote:
      "Family T-shirt Printing a wordo recomendá na Best Bizz y for di e promé meeting caba, nos a sinti cu e relacion di trabou lo ta uno super! Best Bizz a cuminsá asistí nos cu e inhaalwerk di henter 1 aña atrasá y di eynan bai Best Bizz a tuma over tur loke ta encerá administratie y tey pa nos den tur situacion. Sea tabata pa contestá un concern, pregunta of pa duna nos un honest advies. Bo por ta trankil unabes bo tin e Team di Best Bizz mahenando e administracion di bo negoshi.",
    name: "Mirouska de Cuba",
    role: "Owner, Family T-Shirt Printing",
    logo: "/clients/family-tshirt.png",
  },
];

export const VALUES = [
  {
    icon: "ShieldCheck",
    title: "Trust",
    text: "We build lasting relationships founded on integrity, confidentiality and dependable service.",
  },
  {
    icon: "Target",
    title: "Accuracy",
    text: "Precise, reliable records you can base important business decisions on with confidence.",
  },
  {
    icon: "Sparkles",
    title: "Simplicity",
    text: "Clear communication and straightforward pricing that make managing your finances easy.",
  },
];

const asset = (p) => `${process.env.PUBLIC_URL || ""}${p}`;

// Real client logos. Append new entries here as more are provided.
export const CLIENT_LOGOS = [
  { name: "297 Sports", src: asset("/clients/297-sports.png") },
  { name: "Around Aruba", src: asset("/clients/around-aruba.png") },
  { name: "Arubian Garden", src: asset("/clients/arubian-garden.png") },
  { name: "Bang!", src: asset("/clients/bang.png") },
  { name: "Clean Wheels Carwash & More", src: asset("/clients/cleanwheels.png") },
  { name: "Craft", src: asset("/clients/craft.png") },
  { name: "Electric Festival", src: asset("/clients/electric-festival.png") },
  { name: "Elisa Lejuez", src: asset("/clients/elisa-lejuez.png") },
  { name: "Elite Productions & Entertainment", src: asset("/clients/elite-productions.png") },
  { name: "EZ Air", src: asset("/clients/ez-air.png") },
  { name: "FactorPlus — Caribbean Factoring Services", src: asset("/clients/factor-plus.png") },
  { name: "First Class Experience Aruba", src: asset("/clients/first-class.png") },
  { name: "Got Junk? Septic Services", src: asset("/clients/got-junk.png") },
  { name: "Häagen-Dazs", src: asset("/clients/haagen-dazs.png") },
  { name: "H-Company", src: asset("/clients/h-company.png") },
  { name: "IBS — Ingenious Business Solutions", src: asset("/clients/ibs.png") },
  { name: "Jay's Tire Repair and Service", src: asset("/clients/jays-tire.png") },
  { name: "Koyari Modern Condos Aruba", src: asset("/clients/koyari.png") },
  { name: "Lion Fish Swim School", src: asset("/clients/lion-fish.png") },
  { name: "M&M Fuel Injector Services", src: asset("/clients/mm-fuel-injector.png") },
  { name: "Madame Janette", src: asset("/clients/madame-janette.png") },
  { name: "Mi Dudu Bar & Restaurant", src: asset("/clients/mi-dudu.png") },
  { name: "NAHR Media", src: asset("/clients/nahr-media.png") },
  { name: "Solution Septic Services", src: asset("/clients/solution-septic.png") },
  { name: "Switch Foundation", src: asset("/clients/switch-foundation.png") },
  { name: "Turibana Plaza", src: asset("/clients/turibana-plaza.png") },
  { name: "Ur Designs", src: asset("/clients/ur-designs.png") },
  { name: "WGET Technologies", src: asset("/clients/wget-technologies.png") },
  { name: "SHASHA", src: asset("/clients/shasha.png") },
  { name: "Family T-Shirt Printing", src: asset("/clients/family-tshirt-full.png") },
];

export const IMAGES = {
  hero: asset("/images/hero.webp"),
  about: asset("/images/about.webp"),
  bookkeeping: asset("/images/aruba-florin.webp"),
  serviceBookkeeping: asset("/images/services/bookkeeping.jpg"),
  servicePayroll: asset("/images/services/payroll.jpg"),
  serviceConsultancy: asset("/images/services/consultancy.jpg"),
};
